<template>
	<v-container
		fluid
		class="sp-container"
		:style="`background-color: ${slider.color};`"
	>
		<div class="progressbar-container">
			<div :class="['progressbar', slider.animations.progress]"></div>
		</div>

		<template v-if="$vuetify.breakpoint.smAndDown">
			<div class="control-for-sm control-for-sm-left">
				<v-btn
					fab
					color="transparent"
					:class="[
						'white--text',
						'elevation-0',
						'animate__animated',
						slider.animations.control_left,
					]"
					@click="sliderChange(Prev)"
				>
					<v-icon>
						mdi-chevron-double-left
					</v-icon>
				</v-btn>
			</div>

			<div class="control-for-sm control-for-sm-right">
				<v-btn
					fab
					color="transparent"
					:class="[
						'white--text',
						'elevation-0',
						'animate__animated',
						slider.animations.control_right,
					]"
					@click="sliderChange(Next)"
				>
					<v-icon>
						mdi-chevron-double-right
					</v-icon>
				</v-btn>
			</div>
		</template>

		<v-row>
			<v-col cols="12" md="5" class="d-flex align-center justify-center">
				<div
					:class="[
						'img-container',
						'animate__animated',
						slider.animations.imgContainer,
					]"
				>
					<img
						@click="
							$router.push({
								name: 'Search',
								query: { categories: slider.categories },
							})
						"
						:src="slider.img"
						alt=""
						:class="[
							'img',
							'animate__animated',
							slider.animations.img,
						]"
					/>
				</div>
			</v-col>

			<v-col
				cols="12"
				md="7"
				:class="[
					'd-flex',
					'flex-column',
					'justify-center',
					$vuetify.breakpoint.smAndDown ? 'pr-4' : 'pr-10',
				]"
				style="overflow: hidden; position: relative;"
			>
				<div
					:class="[
						'd-flex',
						'flex-column',
						$vuetify.breakpoint.smAndDown ? 'mb-1' : 'mb-10',
					]"
				>
					<span
						:class="[
							'sp-title',
							'animate__animated',
							slider.animations.title,
						]"
					>
						{{ slider.title }}
					</span>

					<span
						:class="[
							'sp-name',
							'animate__animated',
							slider.animations.name,
							$vuetify.breakpoint.smAndDown ? 'ml-0' : 'ml-15',
						]"
					>
						{{ slider.name }}
					</span>
				</div>

				<span
					:class="[
						'title-desc',
						'animate__animated',
						slider.animations.desctitle,
					]"
				>
					DESCRIPCIÓN:
				</span>

				<p
					:class="[
						'sp-description',
						'animate__animated',
						slider.animations.description,
						$vuetify.breakpoint.smAndDown
							? 'mt-1 ml-0'
							: 'mt-5 ml-13',
					]"
				>
					{{ `${slider.description} (TEXTO PARA FINES DE PRUEBA)` }}
				</p>

				<div
					:class="[
						'd-flex',
						'mb-10',
						$vuetify.breakpoint.smAndDown
							? 'justify-center'
							: 'justify-end',
					]"
				>
					<v-btn
						large
						color="warning"
						:block="$vuetify.breakpoint.smAndDown"
						@click="
							$router.push({
								name: 'PrductShow',
								params: { id: slider.product_id },
							})
						"
						:class="['animate__animated', slider.animations.button]"
					>
						ver producto
					</v-btn>
				</div>

				<div
					class="controls-container"
					v-if="$vuetify.breakpoint.mdAndUp"
				>
					<v-tooltip top v-for="(i, key) in sliders" :key="key">
						<template v-slot:activator="{ on, attrs }">
							<div
								v-bind="attrs"
								v-on="on"
								@click="sliderChange(key)"
								:class="[
									'control',
									{
										'control-active': sliderKey == key,
									},
								]"
							></div>
						</template>
						<span style="text-transform: uppercase;">
							{{ sliders[key].name }}
						</span>
					</v-tooltip>
				</div>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
// import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";

export default {
	name: "Vinilicas",

	props: ["sliders"],

	data() {
		return {
			animations: {
				in: {
					control_left: "animate__slideInLeft animate__fast",
					control_right: "animate__slideInRight animate__fast",
					progress: "progressbar-animate",
					imgContainer: "animate__bounceIn",
					img: "animate__zoomIn animate__fast",
					name: "animate__fadeInDown animate__fast",
					title: "animate__fadeInRight animate__fast",
					desctitle: "animate__slideInLeft animate__fast",
					description: "animate__fadeInRight animate__fast",
					button: "animate__fadeInUp",
				},

				out: {
					control_left: "animate__slideOutLeft animate__fast",
					control_right: "animate__slideOutRight animate__fast",
					progress: "",
					imgContainer: "animate__bounceOut",
					name: "animate__fadeOutUp animate__fast",
					img: "animate__zoomOut animate__fast",
					title: "animate__fadeOutLeft animate__fast",
					desctitle: "animate__slideOutRight animate__fast",
					description: "animate__fadeOutLeft animate__fast",
					button: "animate__fadeOutDown",
				},
			},

			slider: {
				color: "#fff",
				animations: {
					control_left: "",
					control_right: "",
					progress: "",
					name: "",
					title: "",
					img: "",
					desctitle: "",
					description: "",
					imgContainer: "",
					button: "",
				},
			},

			sliderKey: 0,

			interval: null,
		};
	},

	created() {
		this.sliderIn();
	},

	methods: {
		sliderChange(key) {
			this.sliderOut();

			setTimeout(() => {
				this.sliderKey = key;

				this.sliderIn();
			}, 800);
		},

		sliderOut() {
			clearTimeout(this.interval);

			this.slider.color = this.sliders[this.getNextKey()].color;
			this.slider.animations = this.animations.out;
		},

		sliderIn() {
			this.slider = {
				...this.sliders[this.sliderKey],
				animations: this.animations.in,
			};

			this.interval = setTimeout(() => {
				this.sliderChange(this.getNextKey());
			}, 10000);
		},

		getNextKey() {
			let nextKey = this.sliderKey + 1;

			if (nextKey >= this.sliders.length) {
				return 0;
			}

			return nextKey;
		},
	},

	computed: {
		Prev() {
			let key = this.sliderKey - 1;

			if (key < 0) {
				return this.sliders.length - 1;
			}

			return key;
		},

		Next() {
			let key = this.sliderKey + 1;

			if (key >= this.sliders.length) {
				return 0;
			}

			return key;
		},
	},
};
</script>

<style lang="css" scoped>
.sp-container {
	min-height: calc(100vh - 90px);
	color: #fff;
	display: flex;
	align-items: center;
	transition: all ease 1s;
}

.img {
	position: relative;
	height: 600px;
	cursor: pointer;
	transition: all 0.4s;
	z-index: 5;
}

.img-container {
	width: 475px;
	height: 475px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	background-color: rgba(255, 255, 255, 0.07);
}

.img-container::after {
	content: "";
	position: absolute;
	width: 550px;
	height: 550px;
	border-radius: 50%;
	background-color: rgba(255, 255, 255, 0.05);
}

.img-container::before {
	content: "";
	position: absolute;
	width: 675px;
	height: 675px;
	border-radius: 50%;
	background-color: rgba(255, 255, 255, 0.03);
}

.sp-title {
	font-weight: 900;
	text-transform: uppercase;
	color: #ffc107;
	font-size: 1.6rem;
}

.sp-name {
	text-transform: uppercase;
	font-size: 3.8rem;
	font-weight: 600;
}

.sp-description {
	text-align: justify;
	letter-spacing: 0.8px;
	line-height: 1.5;
	font-size: 1.2rem;
	opacity: 0.3;
}

.title-desc {
	position: relative;
}

.controls-container {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	display: flex;
	justify-content: center;
}

.control {
	opacity: 0.4;
	height: 20px;
	width: 20px;
	cursor: pointer;
	margin-left: 10px;
	border-radius: 50%;
	background-color: #fff;
	transition: all 0.8s;
}
.control-active {
	width: 40px;
	border-radius: 10px;
	opacity: 1;
}

.progressbar-container {
	position: fixed;
	left: 0;
	top: 90px;
	z-index: 100;
	width: 100%;
}

.progressbar-container .progressbar {
	height: 3px;
	width: 0;
	background-color: rgba(255, 255, 255, 0.6);
}

.progressbar-animate {
	animation: progressbar 10s linear;
}

@keyframes progressbar {
	from {
		width: 0;
	}
	to {
		width: 100%;
	}
}

.control-for-sm {
	position: absolute;
	top: 250px;
	z-index: 20;
}

.control-for-sm-right {
	right: 15px;
}

/*Extra small < 600px*/
@media (min-width: 0) and (max-width: 600px) {
	.img {
		height: 275px;
	}

	.img-container {
		width: 230px;
		height: 230px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		background-color: rgba(255, 255, 255, 0.25);
	}

	.img-container::after {
		width: 325px;
		height: 325px;
	}

	.img-container::before {
		width: 390px;
		height: 390px;
	}

	.sp-title {
		font-size: 1rem;
	}

	.sp-name {
		font-size: 2.5rem;
	}

	.sp-description {
		/*text-align: center;*/
		letter-spacing: 0.8px;
		font-size: 0.9rem;
	}
}

/*Small	sm	Small to medium tablet	600px > < 960px*/
@media (min-width: 601px) and (max-width: 960px) {
	.img {
		height: 300px;
	}

	.img-container {
		width: 230px;
		height: 230px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		background-color: rgba(255, 255, 255, 0.25);
	}

	.sp-title {
		font-size: 1rem;
	}

	.sp-name {
		font-size: 2.5rem;
	}

	.sp-description {
		/*text-align: center;*/
		letter-spacing: 0.8px;
		font-size: 0.9rem;
	}
}
</style>
